var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15.4082,
    width: 14,
    height: 1.59215,
    rx: 0.796073,
    fill: "#0075FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 10.7232L10.4697 7.92957C10.7626 7.62871 11.2374 7.62871 11.5303 7.92957C11.8232 8.23043 11.8232 8.71821 11.5303 9.01907L7.53033 13.1278C7.23744 13.4287 6.76256 13.4287 6.46967 13.1278L2.46967 9.01907C2.17678 8.71821 2.17678 8.23043 2.46967 7.92957C2.76256 7.62871 3.23744 7.62871 3.53033 7.92957L6.25 10.7232L6.25 0.770393C6.25 0.344917 6.58579 0 7 0C7.41421 0 7.75 0.344917 7.75 0.770393L7.75 10.7232Z",
    fill: "#0075FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.94d0a97efccae35420304f64022a2515.svg";
export { ForwardRef as ReactComponent };